import Icon from "@mui/material/Icon";
import Tooltip from "@material-ui/core/Tooltip";

const quickMenus = [
  {
    icon: (
      <Tooltip title="Menu's Dashboard">
        <Icon fontSize="medium">view_carousel</Icon>
      </Tooltip>
    ),
    name: "Menu's Dashboard",
    key: "menu-dashboard",
    url: "/app/menudashboard/home",
    description: "Menu",
  },
  {
    icon: (
      <Tooltip title="Default Dashboard">
        <Icon fontSize="medium">dashboard</Icon>
      </Tooltip>
    ),
    name: "Default Dashboard",
    key: "auth-default",
    url: "/app/home",
    description: "Dashboard",
  },
];

export { quickMenus };
